<template>
    <div v-if="value.qty > 0" class="grid-x item">
        <div class="small-4 medium-2 cell"><img class="thumb" :src="value.thumb" :alt="value.name" /></div>
        <div class="small-8 hide-for-medium cell">
            <p v-html="value.name"></p>
        </div>
        <div class="small-12 medium-6 large-5 cell">
            <div class="grid-x detail">
                <div class="cell hide-for-small-only"><p v-html="value.name"></p></div>
                <div v-if="value.options.length" class="medium-8 cell">
                    <select v-model="value.size" v-on:change="$updateWishlistItem(value.code)">
                        <option v-for="(option,key) in value.options" :value="option.code">{{ option.name }} @ <span v-html="option.price"></span></option>
                    </select>
                </div>
                <div v-else-if="value.size" class="cell">
                    <p><b>Size:</b> {{ value.displaysize }}</p>
                </div>
                <div class="cell" v-if="value.extras.length"><b>Extras:</b></div>
                <div class="cell" v-for="extra in value.extras"><p class="extra">{{ extra.name }} <span class="show-for-medium" v-html="'(' + extra.cost + ' ' + extra.vat + ')'"></span></p></div>
            </div>
        </div>
        <div class="small-12 medium-4 large-4 large-offset-1 cell detail">
            <div class="grid-x ">
                <div class="small-1 cell hide-for-medium"><label class="middle">Qty: </label></div>
                <div class="small-3 medium-5 large-4 cell">
                    <div class="input-group">
                        <div class="input-group-button">
                            <button class="tiny minus button" @click="reducequantity($event)">-</button>
                        </div>
                        <input class="input-group-field" type="number" :bind="value" v-model="value.qty" disabled>
                        <div class="input-group-button">
                            <button class="tiny plus button" @click="increasequantity($event)">+</button>
                        </div>
                    </div>

                </div>
                <div class="small-2 small-offset-1 cell  hide-for-medium"><label class="middle">Price:</label></div>
                <div class="small-3 medium-5 large-offset-1 cell"><p class="price"><span v-if="value.buyable" v-html="value.lineprice"></span></p></div>    
                <div class="small-2 medium-2 cell"><button class="remove" v-on:click="removeitem"><img src="/assets/images/icons/Remove_Bin_icn.svg" alt="remove item"  /></button></div>    
            </div>
            <div class="grid-x grid-padding-x">
                <div class="small-6 cell"><a v-if="value.uri" class="link" :href="value.uri">View product</a></div>
                <div class="small-6 cell"><a class="link" v-if="value.buyable" @click="addtobasket($event)">Add to basket</a></div>
            </div>
        </div>

    </div>
</template>
<script setup>
    import { useBasketStore } from '@/stores/basket'

    const basket = useBasketStore()
    const value = defineModel()

    function removeitem() {
        if (confirm('Remove ' + value.value.name + ' from your wishlist?')) {
            value.value.qty = 0
            updateWishlistItem(value.value)
        }
    }

    function reducequantity() {
        if(value.value.qty == 1) {
            removeitem.value(event)
        }else {
            value.value.qty -= 1
            updateWishlistItem(event)
        }
    }

    function increasequantity() {
        value.value.qty += 1
        updateWishlistItem(value.value)
    }

    function updateWishlistItem(index) {
        basket.updateWishlistItem(basket.wishlist.items[index])
    }

    function addtobasket() {
        basket.add(value.value.code,value.value.type,value.value.qty)
    }
</script>